module.exports = __webpack_public_path__ + "static/img/04.9804356.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/05/04.jpg
// module id = Rdqf
// module chunks = 0